import { CommonModule } from '@angular/common';
import { Component,Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MatLegacyDialogModule as MatDialogModule,
    MatLegacyDialogRef as MatDialogRef,
    MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { ArlOutput } from '../select-arl-dialog/select-arl-dialog.component';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { HintIconComponent } from '../../../hint-icon/hint-icon.component';



export type ItemNumberInformation = [ItemNumber: string, Information: string];

export interface DuplicatePositionsDialogData {
    selected: ArlOutput[];
    existing: ItemNumberInformation[];
    disableOkButton: boolean
}

export type DuplicatePositionsDialogResult = { action: 'ok' } | { action: 'force' };

@Component({
    selector: 'app-duplicate-positions-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule, AppButtonModule, HintIconComponent],
    templateUrl: './duplicate-positions-dialog.component.html',
    styleUrls: ['./duplicate-positions-dialog.component.scss'],
})
export class DuplicatePositionsDialogComponent {
    constructor(public dialogRef: MatDialogRef<DuplicatePositionsDialogComponent, DuplicatePositionsDialogResult | undefined>, @Inject(MAT_DIALOG_DATA) public data: DuplicatePositionsDialogData) {}


    cancel(): void {
        this.dialogRef.close(undefined);
    }


    ok(): void {
        this.dialogRef.close({ action: 'ok' });
    }


    forceTakeOver(): void {
        // TODO:
        this.dialogRef.close({ action: 'force' });
    }
}
